import React, { useState, useCallback, useMemo, useRef, useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../../../components/header";
import { useIntl } from "react-intl";
import MeSkeleton from '../../../components/skeleton';
import { fetchUnifiedProcessing } from "../../../utils";
import { useParams } from "react-router-dom";
import { fetchGetReturnOrderDetail } from "../../../../../../api";
import { FormattedMessage } from "react-intl";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../../constants";
import SelectLogistics from "./fragments/select-logistics";
import { fetchUploadImage } from "../../../../../../api";
import { useDispatch } from "react-redux";
import { setCustomerLoading, setSuccessReminder } from "../../../../../../store/actions/pages/customer";
import { BigButton } from "../../../../../components/button";
import { fetchAddReturnLogistics, fetchEditReturnLogistics } from "../../../../../../api";
import Toast from "../../../../../components/toast";


const LogisticsCompany = props =>{
    const { logistics, setShowModal } = props;

    return <div className={`${cls.LogisticsContainer} ${cls.LogisticsCompany}`}>
        <div className={cls.Title}><span className={cls.Red}>*</span><span><FormattedMessage id="logisticsCompany" defaultMessage="Logistics Company" /></span></div>

        <div className={cls.Container}>
            <span className={cls.Font}>{logistics?.logisticsCompany}</span>

            <Iconfont className={cls.Icon} onClick={() =>setShowModal(true)}>&#xe694;</Iconfont>
        </div>
    </div>
}

const TrackingNumber = props =>{
    const { logistics, changeLogistics } = props;

    const handleUndate = useCallback((value) =>{
        changeLogistics({ trackingNumber: value });
    }, []);

    return <div className={`${cls.LogisticsContainer} ${cls.TrackingNumber}`}>
        <div className={cls.Title}><span className={cls.Red}>*</span><span><FormattedMessage id="tracknum" defaultMessage="Tracking Number" /></span></div>
    
        <div className={cls.InputCon}>
            <input type="text" 
                value={logistics?.trackingNumber} 
                onChange={(evt) =>handleUndate(evt.target.value)}
            />

            <Iconfont 
                className={cls.CloseIcon} 
                style={{display: `${logistics?.trackingNumber ? 'black' : 'none'}`}} 
                onClick={() =>handleUndate('')} 
            >&#xe7c5;</Iconfont>
        </div>
    </div>
}

const UploadReceipt = props =>{
    const { logistics, changeLogistics } = props;
    const loadImageCount = useRef(3);
    const dispatch = useDispatch();

    const uploadedImages = useMemo(() =>{
        return logistics?.receiptFiles?.map(item=>item?.url);
    }, [logistics]);

    const removeImage = useCallback((index) =>{
        let receiptFiles = [...logistics?.receiptFiles];
        receiptFiles?.splice(index, 1);
        changeLogistics({ receiptFiles });
    }, [logistics]);

    const loadImage = useCallback(async (evt) =>{
        if(!(evt.target.files?.length > 0)){
            return;
        }
        dispatch(setCustomerLoading(true));
        let formData = new FormData();
        formData.append("type","returnLogistics");
       
        let files = Array.from(evt.target.files);
        files?.forEach(file =>{
            formData.append("files", new File([file], file?.name));
        });
        
        let response = await fetchUploadImage(formData, { 'Content-Type': 'application/x-www-form-urlencoded' });
        if(response?.code === 200 && response?.result){
            const { result } = response;
            let receiptFiles = [...logistics?.receiptFiles, ...result]?.slice(0, loadImageCount.current);
            changeLogistics({ receiptFiles });
        }
        dispatch(setCustomerLoading(false));
    }, [logistics]);

    return <div className={`${cls.LogisticsContainer} ${cls.UploadReceipt}`}>
        <div className={cls.Title}><span className={cls.Red}>*</span><span><FormattedMessage id="upload_receipt" defaultMessage="Upload Receipt" /></span></div>
    
        <div className={cls.Message}>
            <FormattedMessage id="a_pooto_package_and_tracking_number" defaultMessage="A photo of the receipt from the shipping company indicating the weight of the package and tracking number." />
        </div>

        <div className={cls.Container}>
            {
               uploadedImages?.map((image, index) =>(
                    <div key={image+index} className={cls.ImageItem}>
                        <img src={`${IMAGE_GEEKO_LTD}${image}`} alt="IMAGE" />
                        <span className={cls.RemoveImg} onClick={() =>removeImage(index)}>&times;</span>
                    </div>
               ))
            }

            {
                ((!uploadedImages?.length) || (uploadedImages?.length < loadImageCount.current)) && <div className={cls.UploadImage}>
                    <form>
                        <input 
                            type="file" 
                            name="imageFiles" 
                            multiple="multiple" 
                            onChange={(e) =>loadImage(e)} 
                            accept="image/jpg,image/jpeg,image/png,image/gif"
                        />
                    </form>

                    <Iconfont className={cls.Icon}>&#xe68c;</Iconfont>

                    <span className={cls.Num}>{uploadedImages?.length || 0} / {loadImageCount.current}</span>
                </div>
            }
        </div>
    </div>
}


const ReturnLogistics = props =>{
    useStyles(cls);
    const Intl = useIntl();
    const params = useParams();
    const dispatch = useDispatch();
    const [orderReturnDetail, setOrderReturnDetail] = useState(null);
    const [logistics, setLogistics] = useState(null);
    const [showModal, setShowModal] = useState(false);


    useEffect(async () =>{
        let response = await fetchGetReturnOrderDetail(params?.returnId);
        setOrderReturnDetail(fetchUnifiedProcessing(response));
        let initLogistics = {
            logisticsCompany: response?.result?.logistics?.logisticsCompany || "",
            trackingNumber: response?.result?.logistics?.trackingNumber || "",
            receiptFiles: response?.result?.logistics?.receiptFiles?.length > 0 ? response.result.logistics.receiptFiles : [],
        };
        setLogistics(initLogistics);
    }, []);

    const changeLogistics = useCallback((params) =>{
        setLogistics(state=>({ ...state, ...params }));
    }, []);

    const handleSubmit = useCallback(async () =>{
        const parameter = {};
        if(params?.returnId){
            parameter['returnOrderId'] = params.returnId
        }

        if(logistics?.logisticsCompany){
            parameter['logisticsCompany'] = logistics.logisticsCompany;
        }else{
            Toast(`${Intl.formatMessage({ id: "logisticsCompany", defaultMessage: "Logistics Company" })} ${Intl.formatMessage({ id: "not_be_empty", defaultMessage: "can not be empty" })}`);
            return;
        }

        if(logistics?.trackingNumber){
            parameter['trackingNumber'] = logistics.trackingNumber;
        }else{
            Toast(`${Intl.formatMessage({ id: "tracknum", defaultMessage: "Tracking Number" })} ${Intl.formatMessage({ id: "not_be_empty", defaultMessage: "can not be empty" })}`);
            return;
        }

        if(logistics?.receiptFiles?.length > 0){
            parameter['receiptFiles'] = logistics.receiptFiles;
        }else{
            Toast(`${Intl.formatMessage({ id: "upload_receipt", defaultMessage: "Upload Receipt" })} ${Intl.formatMessage({ id: "not_be_empty", defaultMessage: "can not be empty" })}`);
            return;
        }
        dispatch(setCustomerLoading(true));
        let response;
        if(logistics?.id){
            parameter['id'] = logistics.id;
            response = await fetchEditReturnLogistics(parameter);
        }else{
            response = await fetchAddReturnLogistics(parameter);
        }
        if(response?.code === 200){
            dispatch(setSuccessReminder({
                commonData:{
                    orderId: orderReturnDetail?.orderId,
                    showHeader:true
                },
                detailReminder:{
                    headerTitle: Intl.formatMessage({ id: "return_logistics", defaultMessage: "Return Logistics" }),
                    title: Intl.formatMessage({ id: "submit_successfully", defaultMessage: "Submitted successfully" }),
                    font: Intl.formatMessage({ id: "check_order", defaultMessage: "You can check your order details to see the progress of your return." }),
                    btns:[
                        {
                            name: Intl.formatMessage({ id: "edit_return_receipt", defaultMessage: "Edit Return Receipt" }),
                            href: `/user/order/return-logistics/${orderReturnDetail?.id}`
                        },
                        {
                            name: Intl.formatMessage({ id: "view_order", defaultMessage: "View Order" }),
                            href: '/user/order/return'
                        }
                    ]
                }
            }));
        }else{

        }
        dispatch(setCustomerLoading(false));
    }, [logistics, orderReturnDetail]);

    return <div>
        <Header 
            centerSlot={Intl.formatMessage({ id: "return_receipt", defaultMessage: "Return Receipt" })} 
        />

        {
            orderReturnDetail ? <div className={cls.ReturnLogistics}>
                <LogisticsCompany logistics={logistics} changeLogistics={changeLogistics} setShowModal={setShowModal} />

                <TrackingNumber logistics={logistics} changeLogistics={changeLogistics} />

                <UploadReceipt logistics={logistics} changeLogistics={changeLogistics} />

                <div className={cls.LogisticsSubmit}>
                    <BigButton onClick={handleSubmit}><FormattedMessage id="submit" defaultMessage="Submit" /></BigButton>
                </div>

                <SelectLogistics show={showModal} onClose={() =>setShowModal(false)} changeLogistics={changeLogistics} />
            </div> : <React.Fragment>
                <MeSkeleton />
            </React.Fragment>
        }
    </div>
}

export default ReturnLogistics;